import React from 'react';
import './App.css';
import SearchForm from "./components/searchForm";
function App() {
  return (
    <div className="App">
      <div>
        <div className="limiter">
          <div className="container-login100">
              In a site far far away......
              <div className="wrap-login100 p-t-50 p-b-90">
              <SearchForm></SearchForm>
            </div>
          </div>
        </div>
      </div>

    </div>

  );
}

export default App;
